export const normalizeClientUser = (user = {}) => ({
  clientUserId: user.clientUserId ?? user.ClientUserId ?? null,
  clientId: user.clientId ?? user.ClientId ?? null,
  userName: user.userName ?? user.UserName ?? user.name ?? "",
  email: user.email ?? user.Email ?? "",
  telephone: user.telephone ?? user.Telephone ?? user.phone ?? "",
  role: (user.role ?? user.Role ?? user.userRole ?? "").toLowerCase(),
});

export const splitClientUsersByRole = (users = []) => {
  const list = (Array.isArray(users) ? users : []).map(normalizeClientUser);

  return {
    fleetManagers: list.filter((user) => user.role === "fleetmanager"),
    superintendents: list.filter((user) => user.role === "superintendent"),
    technicalExecutives: list.filter((user) => user.role === "technicalexecutive"),
  };
};
